// /look: your character and every skin. The screen is web/wardrobe.ts; a phone in a room opens it over the game at this
// same address, and a reload there lands here, with the way back to the game.
import { $, icon, t, whenShown } from '../web/common.ts';
import { SBACCT } from '../web/account.ts';
import { mountLook, myCharacter, playBuzz } from '../web/wardrobe.ts';
import { lookSeen, mountNav } from '../web/nav.ts';
import { keepFriendCount } from '../web/nav-friends.ts';

document.title = t('Your look') + ' · SongBuzz';
const room = (new URLSearchParams(location.search).get('r') || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 4);
if (room) document.querySelector('.sitebar')!.insertAdjacentHTML('afterbegin', `<a class="barback" href="/play?r=${room}" aria-label="${t('Back')}">${icon('back')}</a>`);
mountLook($('#main'), { who: myCharacter(), from: room ? 'look_room' : 'look', sound: playBuzz });
if (SBACCT) SBACCT.account();
if (!room) { mountNav('look'); whenShown.then(lookSeen); keepFriendCount(); }
else { document.querySelectorAll('.tabs, .navfoot').forEach((n) => n.remove()); document.documentElement.classList.remove('hasnav'); } // (from a game it's still the game's: its way back, no nav)
